import { Injectable } from '@angular/core';
import { Anios } from '@core/interfaces/catalogos.intefaces';
import { Request } from '@core/models/requests.model';

@Injectable({
  providedIn: 'root',
})
export class AniosSeminuevosService {
  private url = `ventas/catalogos/seminuevos/anio/search`;

  constructor(private request: Request) {}

  getAnios(body:any) {
    const options = { headers: this.request.headers };
    return this.request.Post<Anios>(this.url,body, options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string): { key: any; value: any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp] }));
  }
}
